import { TrackDef } from '../track.js';

/**
 * SANDSONG RUN — Duneworks, intermediate sprint.
 * A point-to-point descent across the singing dunes: three long crests with
 * two launches off the tops, wide forgiving road, and a weave through the
 * half-buried machine ruins before the downhill run to the finish.
 */
export const sandsong: TrackDef = {
  id: 'sandsong',
  name: 'Sandsong Run',
  tagline: 'Crest, fly, land, repeat — the dunes sing loudest at full throttle.',
  environment: 'duneworks',
  difficulty: 2,
  layout: 'sprint',
  defaultLaps: 1,
  width: 30,
  unlockLevel: 3,
  points: [
    { x: -60, y: 126, z: -260 }, // entry tangent handle
    { x: 0, y: 115, z: 0, width: 32 },
    { x: 60, y: 104, z: 260, width: 32 },
    { x: 170, y: 92, z: 500, width: 30, roll: -0.15 },
    { x: 150, y: 100, z: 740, width: 30 },
    { x: 60, y: 80, z: 980, width: 30, roll: 0.18 },
    { x: -80, y: 68, z: 1180, width: 28, roll: 0.2 },
    { x: -140, y: 76, z: 1420, width: 30 },
    { x: -80, y: 60, z: 1660, width: 28, roll: -0.18 },
    { x: 60, y: 52, z: 1860, width: 28, roll: -0.2 },
    { x: 140, y: 58, z: 2100, width: 30 },
    { x: 120, y: 44, z: 2350, width: 28 },
    { x: 20, y: 38, z: 2560, width: 26, roll: 0.15 },
    { x: -90, y: 34, z: 2760, width: 26, roll: -0.15 },
    { x: -60, y: 30, z: 3000, width: 28 },
    { x: 40, y: 26, z: 3230, width: 30, roll: -0.12 },
    { x: 80, y: 22, z: 3480, width: 32 },
    { x: 60, y: 20, z: 3720, width: 34 },
    { x: 40, y: 18, z: 3960 }, // exit tangent handle
  ],
  features: [
    { kind: 'boost', s: 0.03, length: 0.007, lane: 0 },
    { kind: 'zone', s: 0.08, length: 0.35, name: 'dunefield' },
    { kind: 'boost', s: 0.135, length: 0.007, lane: 0 },
    { kind: 'jump', s: 0.2, length: 0.012 },
    { kind: 'boost', s: 0.51, length: 0.007, lane: -0.3 },
    { kind: 'jump', s: 0.575, length: 0.011 },
    { kind: 'zone', s: 0.635, length: 0.13, name: 'ruins' },
    { kind: 'boost', s: 0.83, length: 0.007, lane: 0.3 },
    { kind: 'boost', s: 0.93, length: 0.007, lane: 0 },
  ],
  medals: { bronze: 49.9, silver: 43, gold: 38.4, author: 35.7 },
};
